import type { MenuRecipesState, Recipe } from 'reducers/menu-recipes/recipes'

export const getOfferedRecipes = (state: MenuRecipesState): Record<string, Recipe> => {
  const uuidToRecipeMap = state.recipesV3.recipes

  return Object.fromEntries(
    Object.entries(uuidToRecipeMap).filter(([_, recipe]) => recipe.isOffered),
  )
}
